import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'migration';
export default {
    savemigrationpinjamanTEMP(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // console.log("##APIS savemigrationpinjamanTEMP.");
                // console.log("#filexls: ", filexls);
                // console.log("#obj: ", obj);
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/savemigrationpinjamanTEMP`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    savemigrationpinjaman(groupmigrationkey) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savemigrationpinjaman`, {groupmigrationkey});
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    savemigrationjaminanTEMP(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/savemigrationjaminanTEMP`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    savemigrationjaminan(groupmigrationkey) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savemigrationjaminan`, {groupmigrationkey});
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    savemigrationangsuranTEMP(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/savemigrationangsuranTEMP`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    savemigrationangsuran(groupmigrationkey) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savemigrationangsuran`, {groupmigrationkey});
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    savemigrationdendaharianTEMP(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/savemigrationdendaharianTEMP`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    savemigrationdendaharian(groupmigrationkey) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savemigrationdendaharian`, {groupmigrationkey});
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    savemigrationpencairandanaTEMP(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/savemigrationpencairandanaTEMP`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    savemigrationpencairandana(groupmigrationkey) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savemigrationpencairandana`, {groupmigrationkey});
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    savemigrationbungaharianTEMP(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/savemigrationbungaharianTEMP`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    savemigrationbungaharian(groupmigrationkey) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savemigrationbungaharian`, {groupmigrationkey});
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    savemigrationpembayaranangsuranTEMP(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/savemigrationpembayaranangsuranTEMP`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    savemigrationpembayaranangsuran(groupmigrationkey) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savemigrationpembayaranangsuran`, {groupmigrationkey});
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    savemigrationpembayaranprkTEMP(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/savemigrationpembayaranprkTEMP`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    savemigrationpembayaranprk(groupmigrationkey) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savemigrationpembayaranprk`, {groupmigrationkey});
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    getmigrationTEMP(obj) {
        // console.log('obj',obj);
        return new Promise(async (resolve, reject) => {
            const keys = ['page', 'limit', 'sortBy', 'sortDir'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
            try {
               const {data} = await axios.get(`${baseurl}/getmigrationTEMP/${obj.groupmigrationkey}/${obj.sheetName}${str}`);
               const { meta, list,count } = data;
               obj.total = meta.total;
               resolve({list,count});
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    removeDataTEMP(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.delete(`${baseurl}/removeDataTEMP/${obj.tablename}/${obj.groupmigrationkey}`);
                resolve(true);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

}